import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { io } from 'socket.io-client';
import PbxContext from '../../context/PbxContext';
import Loading from '../../components/Loading/LoadingModule';
import EndpointsList from '../../components/Endpoints/EndpointsList';
import EndpointRegistrationModal from '../../components/Endpoints/EndpointRegistrationModal';
import WebRTC from './components/WebRTC';
import Callcenter from '../Callcenter'
import { fetchEndpoints, accessLocalStorage, exportSelectAllEndpoints, getMusicOnHoldData } from '../../services';
import { scopeByTenant } from '../../services/tenantScope';
import './styles.css';


function Home() {
  const [loading, setLoading] = useState(true);
  const [registrationEndpoint, setRegistrationEndpoint] = useState(null);
  const getItensStateGlobal = useContext(PbxContext);
  const { endpoints, setEndpoints, ipEndpoints, setIpEndpoints, setActiveCallsByEndpoint } = getItensStateGlobal;

  const history = useHistory();

  const getAllEndpointsConfig = async () => {
    const endpointsList = await exportSelectAllEndpoints();

    if(endpointsList === undefined) return setLoading(true);
    const elements = endpointsList.reduce((acc, cur) => {
      const getNameEndpoint = cur.callerid.split(' ');
      acc[`${cur.endpoint}`] = { name: getNameEndpoint.length > 2 ? `${cur.callerid.split(' ')[0]} ${cur.callerid.split(' ')[1]}` : cur.callerid.split(' ')[0], accountcode: cur.tenant };
      return acc;
    },{})
    return elements;
  };

  const getApiEndpoints = useCallback(async () => {
    let endpointsFetcheds = await fetchEndpoints();

    const byBase = new Map();
    for (const ep of endpointsFetcheds) {
      const base = ep.resource.replace(/-web$/, '');
      if (!byBase.has(base)) {
        byBase.set(base, { ...ep, resource: base, channel_ids: [...(ep.channel_ids || [])] });
        continue;
      }
      const agg = byBase.get(base);
      if (ep.state === 'online') agg.state = 'online';
      agg.channel_ids = [...agg.channel_ids, ...(ep.channel_ids || [])];
    }
    endpointsFetcheds = Array.from(byBase.values()).filter((ep) => !isNaN(Number(ep.resource)));

    const endpointsConfig = await getAllEndpointsConfig();

    let endpointsReceived = endpointsFetcheds.map((element) => {
      endpointsConfig.hasOwnProperty(`${element.resource}`) && !isNaN(element.resource) ? element['name'] = endpointsConfig[`${element.resource}`].name : element.resource;
      if (!element.hasOwnProperty('name')) element.name = element.resource;
      if (endpointsConfig.hasOwnProperty(`${element.resource}`)) element['accountcode'] = endpointsConfig[`${element.resource}`].accountcode;
      delete element.technology
      return element;
    });

    if (endpointsReceived) {
      setLoading(false);

      const dataUser = await accessLocalStorage.getUserLocalStorage();
      let { user: { endpointsviewer, idtenant, role }} = dataUser;

      endpointsReceived = scopeByTenant(endpointsReceived, (endpoint) => endpoint.accountcode, idtenant);

      const visibility = endpointsviewer !== 'all' ? endpointsviewer.split(',') : [];

      const endpointsForViewer = visibility.length > 0 ? endpointsReceived.filter((endpoint) => {
        if(visibility.includes(endpoint.resource)) return endpoint;
      }) : endpointsReceived;
      setEndpoints(endpointsForViewer);
    }
  }, [setEndpoints]);

  const socketRef = React.useRef(null);
  const endpointsRef = React.useRef(endpoints);
  endpointsRef.current = endpoints;

  useEffect(() => {
    const validateUserLogged = async () => {
      const dataUser = await accessLocalStorage.getUserLocalStorage();
      if (!dataUser) return history.push('/');
      await getApiEndpoints();
    };
    validateUserLogged();
    const refreshInterval = setInterval(getApiEndpoints, 60000);
    return () => clearInterval(refreshInterval);
  }, [getApiEndpoints, history]);

  useEffect(() => {
    let mounted = true;
    (async () => {
      const { ipRequest } = await accessLocalStorage.getUserLocalStorage();
      if (!mounted) return;
      const baseHost = ipRequest.replace(/^https?:\/\//, '').split('/')[0];
      const dbLocal = localStorage;
      const socket = io(`//${baseHost}`, { path: '/io/' });
      socketRef.current = socket;

      socket.on('endpoint-status', (obj) => {
        if (obj.type !== 'ContactStatusChange') return;
        const rawResource = obj.endpoint?.resource;
        if (!rawResource) return;
        const baseResource = rawResource.replace(/-web$/, '');
        const stateEndpoint = obj.endpoint?.state;

        let ipEndpoint = '';
        if (obj.contact_info?.uri && obj.contact_info.uri.includes('@')) {
          const part = obj.contact_info.uri.split('@')[1] || '';
          ipEndpoint = part.split(':')[0] || part.split(';')[0] || part;
        }
        const sendDbEndpoint = {
          endpoint: baseResource,
          name: endpointsRef.current[`${baseResource}`],
          state: stateEndpoint,
          ip: ipEndpoint,
        };
        if (stateEndpoint !== 'offline') dbLocal.setItem(baseResource, JSON.stringify(sendDbEndpoint));
        if (stateEndpoint === 'offline') dbLocal.removeItem(baseResource);
        setIpEndpoints(sendDbEndpoint);

        setEndpoints((prev) => prev.map((ep) => {
          if (ep.resource !== baseResource) return ep;
          const hasChannels = (ep.channel_ids?.length || 0) > 0;
          const newState = stateEndpoint === 'offline' && !hasChannels
            ? 'offline'
            : (stateEndpoint === 'offline' ? ep.state : 'online');
          return { ...ep, state: newState };
        }));
      });
    })();
    return () => {
      mounted = false;
      if (socketRef.current) {
        socketRef.current.disconnect();
        socketRef.current = null;
      }
    };
  }, [setIpEndpoints]);

  return (
    <div className="home-container">
      {loading ? (
        <Loading />
      ) : (
        <div className="home-content">
          <div className="home-section endpoints-section">
            <div className="section-header">
              <div className="section-title-wrapper">
                <svg className="section-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                </svg>
                <div>
                  <h2 className="section-title">Ramais</h2>
                  <p className="section-subtitle">Gerencie, monitore e controle seus ramais</p>
                </div>
              </div>
            </div>
            <div className="section-content">
              <EndpointsList onOpenRegistration={setRegistrationEndpoint} />
            </div>
          </div>

          <div className="home-section callcenter-section">
            <Callcenter />
          </div>
        </div>
      )}
      {registrationEndpoint && (
        <EndpointRegistrationModal
          key={registrationEndpoint}
          endpoint={registrationEndpoint}
          onClose={() => setRegistrationEndpoint(null)}
        />
      )}
    </div>
  );
}

export default Home;
